import React, { ReactNode, useRef, useState } from 'react';
import { v4 as guid } from 'uuid';
import { Icon } from '../Icon';

import './styles.scss';

export interface PopupMenuOption {
    icon: string;
    text: string;
    onClick: () => void;
    itemClassName?: string;
}

interface Props {
    children: ReactNode;
    options: PopupMenuOption[];
    align?: 'left' | 'center' | 'right';
    className?: string;
}

export const PopupMenu = ({ children, options, align = 'center', className = '' }: Props) => {
    const buttonRef = useRef<HTMLDivElement>(null);
    const popupRef = useRef<HTMLDivElement>(null);
    const [showPopup, setShowPopup] = useState(false);

    const onButtonClick = () => {
        setShowPopup(true);
        if (buttonRef && buttonRef.current) {
            const sortButtonWidth = buttonRef.current.offsetWidth;
            const sortButtonHeight = buttonRef.current.offsetHeight;

            if (popupRef && popupRef.current) {
                const popupWidth = popupRef.current.offsetWidth;
                popupRef.current.style.top = `${sortButtonHeight + 10}px`;

                switch (align) {
                    case 'left':
                        popupRef.current.style.left = '0';
                        break;
                    case 'right':
                        popupRef.current.style.right = '0';
                        break;
                    case 'center':
                    default:
                        popupRef.current.style.left = `calc(-1 * ((${popupWidth}px - ${sortButtonWidth}px) / 2))`;
                        break;
                }
            }
        }
    };

    return (
        <>
            <div className={`popup-menu ${className}`}>
                <div className='popup-menu__button' onClick={onButtonClick} ref={buttonRef}>
                    {children}
                </div>
                <div
                    className={`popup-menu__popup ${
                        showPopup ? 'popup-menu__popup--visible' : 'popup-menu__popup--hidden'
                    }`}
                    ref={popupRef}
                >
                    {options.map((option) => (
                        <div
                            className={`popup-menu__popup-item ${option.itemClassName ? option.itemClassName : ''}`}
                            key={guid()}
                            onClick={() => {
                                option.onClick();
                                setShowPopup(false);
                            }}
                        >
                            <Icon className='popup-menu__popup-icon' icon={option.icon} size='20' />
                            {option.text}
                        </div>
                    ))}
                    <div className='popup-menu__popup-close-icon' onClick={() => setShowPopup(false)}>
                        <Icon icon='xmark-regular' size='24' color='white' />
                    </div>
                </div>
            </div>
            {showPopup && <div className='popup-menu__overlay' onClick={() => setShowPopup(false)}></div>}
        </>
    );
};
